import { render, staticRenderFns } from "./FinancialMerchantStatistics.vue?vue&type=template&id=2fc0dc31&"
import script from "./FinancialMerchantStatistics.vue?vue&type=script&lang=ts&"
export * from "./FinancialMerchantStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FinancialMerchantStatistics.vue"
export default component.exports